import AddAccountForm from './AddAccountForm';
import React, { useState, useEffect } from 'react'
import { Column, Row } from 'simple-flexbox';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Toolbar, InputAdornment } from '@material-ui/core';
import useTable from "../../../utilities/useTable";
import { ToastContainer } from 'react-toastify';
import StatComponent from '../../stat-page/StatComponent';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from '@material-ui/icons/Add';
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";


const useStyles = makeStyles(theme => ({
    pageContent: {
        margin: theme.spacing(5),
        padding: theme.spacing(3)
    },
    searchInput: {
        width: '75%'
    },
    newButton: {
        position: 'absolute',
        right: '10px'
    }
}))


const headCells = [
    { id: 'bankNAme', label: 'Bank Name' },
    { id: 'accountNumber', label: 'Account Number' },
    { id: 'accountName', label: 'Account Name' },
    { id: 'actions', label: 'Actions', disableSorting: true }
]

export function Account({ accounts, LoadAccount, AddAccount, DeleteAccount ,companyId}) {


    const classes = useStyles();
    const [recordForEdit, setRecordForEdit] = useState(null)
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [openPopup, setOpenPopup] = useState(false)
    const [addOpenPopup, setAddOpenPopup] = useState(false)
    const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(accounts, headCells, filterFn);
    useEffect(() => {
        LoadAccount(companyId)
        return () => {

        }
    }, [])

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {

                if (target.value === "")
                    return items;
                else
                    return items.filter(x => x.accountName.toLowerCase().includes(target.value))
            }
        })
    }

    const addOrEdit = (Account, resetForm) => {
        if (Account.id === 0)
            AddAccount(Account)
        else {

        }

    }




    const addAccount = (Account, resetForm) => {
        AddAccount(Account)
        resetForm()
        setRecordForEdit(null)
        setAddOpenPopup(false)
        setOpenPopup(false)
    }

    const openInPopup = item => {
        setRecordForEdit(item)
        setOpenPopup(true)
    }

    const onDelete = id => {
        DeleteAccount(id)
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false
        })
    }
    return (
        <>
            <div className="container" style={{ width: "100rem", position: "relative", left: "7.8rem" }}>
                <div>
                    <Column flexGrow={1}>
                        <ToastContainer />
                        <div className="mt-5" style={{ position: "relative", left: "2.5rem" }}>
                            <Controls.Input
                                // label="Search Account by Account Name"
                                placeholder="Search Account by Account Name"
                                className={classes.searchInput}
                                InputProps={{
                                    startAdornment: (<InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>)
                                }}
                                onChange={handleSearch}
                            />
                        </div>
                        <Paper className={classes.pageContent}>
                            <h4> <strong> Account Setup </strong></h4>
                            <Toolbar>
                                <Controls.Button
                                    text="Add New"
                                    variant="outlined"
                                    startIcon={<AddIcon />}
                                    className={classes.newButton}
                                    onClick={() => { setAddOpenPopup(true); setRecordForEdit(null); }}
                                />
                            </Toolbar>
                            <TblContainer>
                                <TblHead />
                                <TableBody>
                                    {

                                        recordsAfterPagingAndSorting().map(item =>
                                        (<TableRow key={item.id}>
                                            <TableCell>{item.bankName}</TableCell>
                                            <TableCell>{item.accountNumber}</TableCell>
                                            <TableCell>{item.accountName}</TableCell>


                                            <TableCell>
                                                {/* <Controls.ActionButton
                                            color="primary"
                                            onClick={() => {
                                                openInPopup(item)
                                            }}>
                                            <EditOutlinedIcon fontSize="small" />
                                        </Controls.ActionButton> */}
                                                <Controls.ActionButton
                                                    color="secondary"
                                                    onClick={() => {
                                                        setConfirmDialog({
                                                            isOpen: true,
                                                            title: 'Are you sure to delete this record?',
                                                            subTitle: "You can't undo this operation",
                                                            onConfirm: () => { onDelete(item.id) }
                                                        })
                                                    }}>
                                                    <CloseIcon fontSize="small" />
                                                </Controls.ActionButton>
                                            </TableCell>
                                        </TableRow>)
                                        )
                                    }
                                </TableBody>
                            </TblContainer>
                            <TblPagination />
                        </Paper>
                        <Popup
                            title="Add Account Form "
                            openPopup={addOpenPopup}
                            setOpenPopup={setAddOpenPopup}
                        >

                            <AddAccountForm
                                recordForEdit={recordForEdit}
                                addAccount={addAccount}

                            />
                        </Popup>
                        <Notification
                            notify={notify}
                            setNotify={setNotify}
                        />
                        <ConfirmDialog
                            confirmDialog={confirmDialog}
                            setConfirmDialog={setConfirmDialog}
                        />
                    </Column>
                </div>
            </div>
        </>
    )
}





function mapStateToProps(state) {
    console.log(state)
    return {
        buttonloader: state.utilityReducer.buttonloader,
        user: state.userReducer.user,
        accounts: state.accountReducer.accounts,
        companyId:state.persistReducer.companyId


    };
}
const mapDispatchToProps = (dispatch) => ({
    LoadAccount(payload) {
        dispatch({ type: "LOAD_ACCOUNTS", payload });
    },
    AddAccount(payload) {
        dispatch({ type: "ADD_ACCOUNT", payload });
    },
    DeleteAccount(payload) {
        dispatch({ type: "DELETE_ACCOUNT", payload });
    },

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Account);